import intl from 'react-intl-universal';

import { ReducerState } from '@/redux/reducers/reservation/cancelReserve';
import { ValidateSchema, createValidator } from '@/pages/reservation/utils/validator';
import { PRICE_REG } from '@/config/reg';

const rentRecordList: (value: ReducerState['rentRecordList']) => void = (value) => {
  const rentList = value || [];

  if (rentList.length) {
    rentList.forEach((item) => {
      const { liquidatedDamages } = item;
      if (!liquidatedDamages) {
        throw new Error(intl.get('drawer_reserve_cancel_error_damages_null'));
      }
      if (!PRICE_REG.test(liquidatedDamages)) {
        throw new Error(intl.get('drawer_reserve_cancel_error_damages_invalid'));
      }
    });
  }

  return null;
};

const mainSchema: ValidateSchema<ReducerState> = {
  rentRecordList,
};

export default createValidator<ReducerState>(mainSchema);
